import fart1 from '../assets/sounds/fart1.mp3';
import fart2 from '../assets/sounds/fart2.mp3';
import fart3 from '../assets/sounds/fart3.mp3';
import ballKick from '../assets/sounds/ball_kick.mp3';
import levelUp from '../assets/sounds/levelup.mp3';
import eat from '../assets/sounds/eat.mp3';
import xpGain from '../assets/sounds/xp_gain.mp3';

// Preload audio elements
const createAudio = (src: string): HTMLAudioElement => {
  const audio = new Audio(src);
  audio.preload = 'auto';
  return audio;
};

// Create audio elements for each sound
const fartSounds = [
  createAudio(fart1),
  createAudio(fart2),
  createAudio(fart3)
];

const ballKickSound = createAudio(ballKick);
const levelUpSound = createAudio(levelUp);
const eatSound = createAudio(eat);
const xpGainSound = createAudio(xpGain);

class SoundService {
  private muted: boolean = false;
  
  // Play a random fart sound
  playFartSound(): void {
    return // Disabled for now
    // if (this.muted) return;
    
    // Get a random fart sound
    const randomIndex = Math.floor(Math.random() * fartSounds.length);
    const sound = fartSounds[randomIndex];
    
    // Reset and play
    sound.currentTime = 0;
    sound.play().catch(error => {
      console.error('Error playing fart sound:', error);
    });
  }
  
  // Play ball kick sound
  playBallKickSound(): void {
    if (this.muted) return;
    
    ballKickSound.currentTime = 0;
    ballKickSound.play().catch(error => {
      console.error('Error playing ball kick sound:', error);
    });
  }

  // Play level up sound
  playLevelUpSound(): void {
    if (this.muted) return;
    
    levelUpSound.currentTime = 0;
    levelUpSound.play().catch(error => {
      console.error('Error playing level up sound:', error);
    });
  }
  
  // Play XP gain sound
  playXPGainSound(): void {
    if (this.muted) return;
    
    xpGainSound.currentTime = 0;
    xpGainSound.play().catch(error => {
      console.error('Error playing XP gain sound:', error);
    });
  }
  
  // Mute/unmute all sounds
  toggleMute(): boolean {
    this.muted = !this.muted;
    return this.muted;
  }
  
  // Set mute state
  setMute(muted: boolean): void {
    this.muted = muted;
  }
  
  // Get current mute state
  isMuted(): boolean {
    return this.muted;
  }

  playEatingSound(): void {
    if (this.muted) return;
    
    eatSound.currentTime = 0;
    eatSound.play().catch(error => {
      console.error('Error playing eating sound:', error);
    });
  }

  // Placeholder for Auto-Clean Fireball sound
  playFireballSound(): void {
    if (this.muted) return;
    // TODO: Add actual fireball sound asset and playback
    console.log("Placeholder: Playing Fireball Sound");
    // Example: 
    // fireballSound.currentTime = 0;
    // fireballSound.play().catch(error => console.error('Error playing fireball sound:', error));
  }

  // Placeholder for Auto-Feature Sparkle sound
  playSparkleSound(): void {
    if (this.muted) return;
    // TODO: Add actual sparkle sound asset and playback
    console.log("Placeholder: Playing Sparkle Sound");
    // Example: 
    // sparkleSound.currentTime = 0;
    // sparkleSound.play().catch(error => console.error('Error playing sparkle sound:', error));
  }
}

// Create and export a singleton instance
const soundService = new SoundService();
export default soundService; 